import React, { createContext, useContext, useState } from "react";
import translations from "../i18n/translations";

const LanguageContext = createContext();

const LANGUAGES = [
  { code: "en", label: "English", flagCode: "us" },
  { code: "de", label: "Deutsch", flagCode: "de" },
  { code: "es", label: "Español", flagCode: "es" },
  { code: "zh", label: "中文", flagCode: "cn" },
];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("beauly_lang") || "en";
  });

  const setLanguage = (code) => {
    setLang(code);
    localStorage.setItem("beauly_lang", code);
  };

  const t = (key) => {
    return translations[lang]?.[key] || translations.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
